<div class="container-fluid">
  <div class="styles-body">
    <div class="panel-body content-body-pages">
      <div class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <mat-icon>comment</mat-icon>
          </div>
          <div class="header-text">
            <h1 class="page-title">{{ 'CommentsManagement' | translate }}</h1>
            <p>{{ 'CommentsManagementDescription' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="filters-section">
        <app-frontend-filter (onFiltersChanged)="onFiltersChanged($event)"
                             [filters]="allFilters">
        </app-frontend-filter>
      </div>
      <div class="comments-management-container">
        <div class="left-section">
          <div class="branch-section">
            <div class="section-title">
              <mat-icon>store</mat-icon>
              <span>{{ 'SelectBranch' | translate }}</span>
            </div>
            <div class="branch-container">
              <div class="branch-grid">
                @if (isLoadingBranches) {
                  <div class="loading-branches">
                    <div class="loading-spinner">
                      <mat-icon>refresh</mat-icon>
                    </div>
                    <p>{{ 'LoadingBranches' | translate }}</p>
                  </div>
                } @else if (branches && branches.length > 0) {
                  @for (branch of branches; track branch.BusinessId) {
                    <div (click)="onBranchClick(branch)"
                         [ngClass]="{'selected': isBranchSelected(branch)}"
                         class="branch-item">
                      <div class="branch-icon">
                        <mat-icon>store</mat-icon>
                      </div>
                      <div class="branch-info">
                        <h4 class="branch-title">{{ branch.Title }}</h4>
                        @if (branch.Address) {
                          <p class="branch-address">{{ branch.Address }}</p>
                        }
                      </div>
                      <div class="branch-selection-indicator">
                        <img [src]="isBranchSelected(branch) ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                             alt="selection">
                      </div>
                    </div>
                  }
                } @else {
                  <div class="no-branches">
                    <mat-icon>store</mat-icon>
                    <p>{{ 'NoBranchesFound' | translate }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="comment-details-section">
            <div class="section-title">
              <mat-icon>comment</mat-icon>
              <span>{{ 'CommentAndOrderDetails' | translate }}</span>
            </div>
            @if (comments && comments.length > 0) {
              <div class="comments-list">
                @for (comment of comments; track comment.CommentId) {
                  <div (click)="selectComment(comment)"
                       [ngClass]="{'selected': selectedComment?.CommentId === comment.CommentId}"
                       class="comment-card">
                    <div class="comment-header">
                      <div class="user-info">
                        <div class="user-avatar">
                          <img alt="User"
                               class="avatar-icon"
                               src="/icons/user.svg">
                        </div>
                        <div class="user-details">
                          <h4>{{ comment.User?.FirstName }} {{ comment.User?.LastName }}</h4>
                          <p class="user-mobile">{{ comment.User?.MobileNumber }}</p>
                          <p class="comment-date">{{ comment.CreateDate | time:'HH:mm - YYYY/MM/DD' }}</p>
                        </div>
                      </div>
                      <div class="comment-status">
                    <span [class]="getStatusClass(comment.Status)"
                          class="status-badge">
                      {{ getStatusText(comment.Status) }}
                    </span>
                      </div>
                    </div>
                    <div class="comment-content">
                      <div class="rating-section">
                        <div class="rating">
                          <span class="rating-value">{{ comment.Rate }}</span>
                          <img alt="Rating"
                               class="star-icon"
                               src="/icons/star.svg">
                        </div>
                      </div>
                      <div class="comment-text">
                        <p>{{ comment.Comment }}</p>
                      </div>
                      <!-- Product Images and Total Price -->
                      @if (comment.Factor?.FactorOrders && comment.Factor.FactorOrders.length > 0) {
                        <div class="product-summary">
                          <div class="product-images">
                            @for (factorOrder of comment.Factor.FactorOrders; track factorOrder.id) {
                              <div class="product-image-small">
                                @if (factorOrder.Order?.ServicePrice?.Service?.Images && factorOrder.Order?.ServicePrice?.Service?.Images.length > 0) {
                                  <img [src]="formatImage('x', factorOrder.Order?.ServicePrice?.Service?.Images[0])"
                                       alt="Product Image"
                                       class="product-img-small">
                                } @else {
                                  <img alt="No Image"
                                       class="product-img-small"
                                       src="/icons/image-placeholder.svg">
                                }
                              </div>
                            }
                          </div>
                          <div class="total-price-simple">
                            <strong>{{ formatPrice(comment.Factor?.PayablePrice) }} {{ 'Currency' | translate }}</strong>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="comment-actions">
                      <app-frontend-button (click)="selectComment(comment, $event)"
                                           [Image]="true"
                                           [class]="'card-main'"
                                           [src]="'/icons/eye.svg'"
                                           title="Details">
                      </app-frontend-button>
                      @if (comment.Status === 'AWAITING_APPROVAL') {
                        <app-frontend-button (click)="approveComment(comment, $event)"
                                             [Image]="true"
                                             [class]="'card-green'"
                                             [disabled]="isProcessingComment === comment.CommentId"
                                             [loading]="isProcessingComment === comment.CommentId"
                                             [src]="'/icons/tick-square.svg'"
                                             title="Approve">
                        </app-frontend-button>
                        <app-frontend-button (click)="rejectComment(comment, $event)"
                                             [Image]="true"
                                             [class]="'card-main-package'"
                                             [disabled]="isProcessingComment === comment.CommentId"
                                             [loading]="isProcessingComment === comment.CommentId"
                                             [src]="'/icons/close-square.svg'"
                                             title="Reject">
                        </app-frontend-button>
                      }
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="no-comments">
                <div class="no-comments-icon">
                  <img alt="no comments"
                       height="80"
                       src="/icons/empty-list.svg"
                       width="80">
                </div>
                <div class="no-comments-content">
                  <h4>{{ 'NoCommentsYet' | translate }}</h4>
                  <p>{{ 'UserCommentsDescription' | translate }}</p>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="right-section">
          <div class="comments-section">
            <div class="section-title">
              <span>{{ 'UserComments' | translate }}</span>
              @if (comments && comments.length > 0) {
                <span class="product-count">({{ comments.length }} نظر)</span>
              }
            </div>

            @if (selectedComment) {
              <div class="comment-details-panel">
                <!-- User Information -->
                <div class="user-section">
                  <h4>{{ 'UserInformation' | translate }}</h4>
                  <div class="user-card">
                    <div class="user-avatar-large">
                      <img alt="User"
                           class="avatar-large"
                           src="/icons/user.svg">
                    </div>
                    <div class="user-info-details">
                      <h5>{{ selectedComment?.User?.FirstName }} {{ selectedComment?.User?.LastName }}</h5>
                      <p>
                        <strong>{{ 'MobileNumberLabel' | translate }}</strong>
                        {{ selectedComment?.User?.MobileNumber }}
                      </p>
                      <p>
                        <strong>{{ 'CommentDateLabel' | translate }}</strong>
                        {{ selectedComment?.CreateDate | time:'HH:mm - YYYY/MM/DD' }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Comment Details -->
                <div class="comment-section">
                  <h4>{{ 'CommentDetails' | translate }}</h4>
                  <div class="comment-details">
                    <div class="rating-display">
                      <span class="rating-label">{{ 'RatingLabel' | translate }}</span>
                      <div class="rating-stars">
                        <span class="rating-value">{{ selectedComment?.Rate }}</span>
                        <img alt="Rating"
                             class="star-icon"
                             src="/icons/star.svg">
                      </div>
                    </div>
                    <div class="comment-text-detail">
                      <span class="comment-label">{{ 'CommentLabel' | translate }}</span>
                      <p class="comment-content">{{ selectedComment?.Comment }}</p>
                    </div>
                    <div class="status-display">
                      <span class="status-label">{{ 'StatusLabel' | translate }}</span>
                      <span [class]="getStatusClass(selectedComment?.Status)"
                            class="status-badge">
                      {{ getStatusText(selectedComment?.Status) }}
                    </span>
                    </div>
                  </div>
                  <!-- Replies Section -->
                  @if (selectedComment?.Replies && selectedComment?.Replies.length > 0) {
                    <div class="replies-section">
                      <h5>{{ 'Replies' | translate }}</h5>
                      <div class="replies-list">
                        @for (reply of selectedComment?.Replies; track reply.User) {
                          <div class="reply-item">
                            <div class="reply-header">
                        <span class="reply-author">
                          <img alt="Admin"
                               class="reply-icon"
                               src="/icons/user.svg">
                          {{ reply.User }}
                        </span>
                            </div>
                            <p class="reply-text">{{ reply.Message }}</p>
                          </div>
                        }
                      </div>
                    </div>
                  }

                  <!-- Reply Form -->
                  <div class="reply-form-section">
                    <div class="action-buttons">
                      <app-frontend-button (click)="showReplyFormToggle()"
                                           [Image]="true"
                                           [class]="'card-main'"
                                           [disabled]="isSubmittingReply"
                                           [src]="'/icons/comment-white.svg'"
                                           [title]="showReplyForm ? 'CancelReply' : 'ReplyToComment'">
                      </app-frontend-button>

                      @if (selectedComment?.Status === 'AWAITING_APPROVAL') {
                        <app-frontend-button (click)="approveComment(selectedComment)"
                                             [Image]="true"
                                             [class]="'card-green'"
                                             [disabled]="isProcessingComment === selectedComment.CommentId || isSubmittingReply"
                                             [loading]="isProcessingComment === selectedComment.CommentId"
                                             [src]="'/icons/tick-square.svg'"
                                             [title]="'ApproveComment'">
                        </app-frontend-button>
                        <app-frontend-button (click)="rejectComment(selectedComment)"
                                             [Image]="true"
                                             [class]="'card-main-package'"
                                             [disabled]="isProcessingComment === selectedComment.CommentId || isSubmittingReply"
                                             [loading]="isProcessingComment === selectedComment.CommentId"
                                             [src]="'/icons/close-square.svg'"
                                             [title]="'RejectComment'">
                        </app-frontend-button>
                      }
                    </div>

                    @if (showReplyForm) {
                      <div class="reply-form">
                        <app-frontend-text-area [(value)]="replyText"
                                                [required]="true"
                                                [title]="'ReplyPlaceholder'"
                                                placeHolder="ReplyPlaceholder">
                        </app-frontend-text-area>
                        <div class="reply-actions">
                          <app-frontend-button (click)="submitReply()"
                                               [Image]="true"
                                               [class]="'card-green'"
                                               [disabled]="isSubmittingReply || !replyText.trim()"
                                               [loading]="isSubmittingReply"
                                               [src]="'/icons/tick-square.svg'"
                                               [title]="'SendReply'">
                          </app-frontend-button>
                          <app-frontend-button (click)="cancelReply()"
                                               [Image]="true"
                                               [class]="'card-yellow'"
                                               [disabled]="isSubmittingReply"
                                               [src]="'/icons/close-square.svg'"
                                               [title]="'Cancel'">
                          </app-frontend-button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <!-- Order Details -->
                <div class="order-section">
                  <h4>{{ 'OrderDetails' | translate }}</h4>
                  <div class="order-info">
                    <div class="order-summary">
                      <p>
                        <strong>{{ 'FactorIdLabel' | translate }}</strong>
                        {{ selectedComment?.Factor?.FactorId }}
                      </p>
                      <p>
                        <strong>{{ 'TotalAmountLabel' | translate }}</strong>
                        {{ formatPrice(selectedComment?.Factor?.PayablePrice) }} {{ 'Currency' | translate }}
                      </p>
                      <p>
                        <strong>{{ 'OrderStatusLabel' | translate }}</strong>
                        {{ getOrderStatusText(selectedComment?.Factor?.Status) }}
                      </p>
                      <p>
                        <strong>{{ 'OrderDateLabel' | translate }}</strong>
                        {{ selectedComment?.Factor?.CreateDate | time:'HH:mm - YYYY/MM/DD' }}
                      </p>
                    </div>
                    <div class="order-items">
                      <h5>{{ 'OrderItems' | translate }}</h5>
                      <div class="order-items-container">
                        @for (factorOrder of selectedComment?.Factor?.FactorOrders; track factorOrder.id) {
                          <div class="order-item">
                            <div class="item-image">
                              @if (factorOrder.Order?.ServicePrice?.Service?.Images && factorOrder.Order?.ServicePrice?.Service?.Images.length > 0) {
                                <img [src]="formatImage('x', factorOrder.Order?.ServicePrice?.Service?.Images[0])"
                                     alt="Service Image"
                                     class="service-image">
                              } @else {
                                <img alt="No Image"
                                     class="service-image"
                                     src="/icons/image-placeholder.svg">
                              }
                            </div>
                            <div class="item-details">
                              <h6>{{ factorOrder.Order?.ServicePrice?.Service?.Title }}</h6>
                              <p class="item-description">{{ factorOrder.Order?.ServicePrice?.Service?.Description }}</p>
                              <div class="item-info">
                                <span class="item-count">{{ 'QuantityLabel' | translate }} {{ factorOrder.Order?.Count }}</span>
                                <span class="item-price">{{ formatPrice(factorOrder.Order?.TotalPrice) }} {{ 'Currency' | translate }}</span>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="no-selection">
                <mat-icon>comment</mat-icon>
                <h3>{{ 'SelectComment' | translate }}</h3>
                <p>{{ 'SelectCommentDescription' | translate }}</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
